import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "icon_url",
      header: "Inactive Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "icon_url_active",
      header: "Active Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url_active")} />,
      enableResizing: false,
      enableSorting: false,
    },
  ];
};
